import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subject, Observable } from 'rxjs';
// import { environment } from '@environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AuthResponse } from './auth-reponse';
import { AuthData } from './auth-data';
import { AccountService } from '../services/account.service';
import { MenuItem, MenuItemPath } from '@enums/menu-item.enum';
import { EnvConfigurationService } from '../services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  //  environment = environment;
  environment = this.envConfigurationService.environment;

  authChanged = new Subject<boolean>();

  private identityApiUrl: string = this.environment.identityApiUrl;
  private baseAccountPath = this.environment.apiUrl + '/account';
  private tokenKey: string = this.environment.tokenKey;
  private rfTokenKey: string = this.environment.rfTokenKey;
  private tokenExpKey: string = this.environment.tokenExpKey;
  // private identityApiUrl: string;
  // private baseAccountPath: string;
  // private tokenKey: string;
  // private rfTokenKey: string;
  // private tokenExpKey: string;
  private tokenURL = 'connect/token';

  tmpOfflineAuth: boolean = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private jwtHelperSrv: JwtHelperService,
    private accountService: AccountService,
    public envConfigurationService: EnvConfigurationService
  ) {
    // this.identityApiUrl = this.environment.identityApiUrl;
    // this.baseAccountPath = this.environment.apiUrl + '/account';
    // this.tokenKey = this.environment.tokenKey;
    // this.rfTokenKey = this.environment.rfTokenKey;
    // this.tokenExpKey = this.environment.tokenExpKey;
  }


  login(authData: AuthData): Observable<AuthResponse> {
    const body = new URLSearchParams();

    // authData.username = "cla",
    // authData.password = "ClaPaco78$"

    body.set('username', authData.username);
    body.set('password', authData.password);
    body.set('grant_type', 'password');
    body.set('scope', 'PacoIdentity');
    body.set('client_id', 'Paco');
    body.set('client_secret', 'paco');

    const options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    };

    return this.http.post<AuthResponse>(this.identityApiUrl + this.tokenURL, body.toString(), options)
      .pipe(
        tap(result => {
          this.saveToken(result.access_token, result.refresh_token, result.expires_in);
          this.authChanged.next(true);
        })
      );
  }

  private saveToken(accessToken: string, refreshToken: string, deadline: number): void {
    const tokenExpDate = new Date();
    tokenExpDate.setSeconds(tokenExpDate.getSeconds() + deadline);

    localStorage.setItem(this.tokenExpKey, tokenExpDate.toString());
    localStorage.setItem(this.tokenKey, accessToken);
    localStorage.setItem(this.rfTokenKey, refreshToken);

  }


  refreshToken(): Observable<AuthResponse> {
    const refreshToken = localStorage.getItem(this.rfTokenKey) || '';

    const httpParams = new HttpParams()
      .append('grant_type', 'refresh_token')
      .append('scope', 'PacoIdentity')
      .append('client_id', 'Paco')
      .append('refresh_token', refreshToken);

    return this.http.post<AuthResponse>(this.identityApiUrl + this.tokenURL, httpParams)
      .pipe(
        tap(result => {
          // this.saveToken(result.access_token, result.refresh_token, result.expires_in);
          this.authChanged.next(true);
        })
      );
  }

  logout() {
    localStorage.clear();
    this.tmpOfflineAuth = false;
    this.authChanged.next(false);
    this.router.navigate(['/login']);
  }


  isAuth(): boolean {
    const decodedToken = this.getDecodedToken();
    if (!decodedToken) {
      return false;
    }
    return !this.isTokenExpired();
  }

  getDecodedToken(): any {
    const token = this.jwtHelperSrv.tokenGetter();
    if (token) {
      return this.jwtHelperSrv.decodeToken(token);
    }

    return null;
  }

  private isTokenExpired(): boolean {
    const tokenExpKey: string = localStorage.getItem(this.tokenExpKey) || '';
    const tokenExpDate = new Date(tokenExpKey);
    const now = new Date();
    return tokenExpDate < now;
  }



  forgetPassword(login: string): Observable<any> {
    const requestOptions: object = {
      /* other options here */
      responseType: 'text'
    };
    const body = {
      login,
      application: this.environment.application
    };
    return this.http.post(this.baseAccountPath + '/forgetpassword',
      body,
      requestOptions
    );
  }

  changeForgetPassword(guid: string, pwd: string): Observable<any> {
    const requestOptions: object = {
      responseType: 'text'
    };
    const params = {
      guid,
      pwd
    };
    return this.http.post(this.baseAccountPath + '/changeforgetpassword', params,
      requestOptions)
      .pipe(
        tap(() => {
          this.router.navigate([MenuItemPath.get(MenuItem.login)]);
        })
      );
  }

  changePassword(newPassword: string): Observable<any> {
    const requestOptions: object = {
      responseType: 'text'
    };
    const params = {
      newPassword
    };
    return this.http.post(this.baseAccountPath + '/changepassword', params,
      requestOptions)
      .pipe(
        tap(() => { })
      );
  }

}
